/*=========================================================================================
  File Name: moduleEcommerceActions.js
  Description: Ecommerce Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import { uuid } from "vue-uuid";
import axios from "../../axios";
import {
  logAddToCart,
  logBeginCheckout,
  logPurchase,
  logAddPaymentInfo,
} from "../../analytics";

export default {
  toggleItemInWishList({ commit }, item) {
    commit("TOGGLE_ITEM_IN_WISH_LIST", item);
  },
  toggleItemInCart({ getters, commit, dispatch }, item) {
    getters.isInCart(item.objectID)
      ? commit("REMOVE_ITEM_FROM_CART", item)
      : dispatch("additemInCart", item);
  },
  additemInCart({ commit }, payload) {
    payload["quantity"] = 1;
    payload["cartItemID"] = uuid.v1();
    commit("ADD_ITEM_IN_CART", payload);
    logAddToCart(payload, 1);
  },
  updateItemQuantity({ commit }, payload) {
    commit("UPDATE_ITEM_QUANTITY", payload);
  },
  async getProducts({ commit }) {
    let payload = await axios.get("/api/products");
    commit("ADD_PRODUCTS", payload.data.products);
  },
  async getCategories({ commit }) {
    let payload = await axios.get("/api/categories");
    commit("ADD_CATEGORIES", payload.data.categories);
  },
  getCartTotalPrice(state) {
    let total = 0;
    state.cartItems.map((product) => {
      total += product.price * product.quantity;
    });
    return total;
  },
  fetchShippingAddress() {
    return axios.get("/api/address");
  },
  saveShippingAddress({ commit }, payload) {
    commit("CART_SAVE_SHIPPING_ADDRESS", payload);
    localStorage.setItem("shippingAddress", JSON.stringify(payload));
  },
  savePaymentMethod({ commit }, payload) {
    commit("CART_SAVE_PAYMENT_METHOD", payload);
    localStorage.setItem("paymentMethod", JSON.stringify(payload));
  },
  submitOrder({ state, getters, commit, dispatch }, orderID) {
    // construct orderItems array
    let orderItems = [];
    state.cartItems.forEach((item) => {
      orderItems.push({
        name: item.title,
        qty: item.quantity,
        ingredients: [
          { sauces: item.selectedSauces },
          { salads: item.selectedSalads },
          { meats: item.selectedMeats },
          { extras: item.selectedExtras },
          { pommRice: item.selectedPommRice },
          { drink: item.selectedDrink },
        ],
        product: item.id,
      });
    });

    const payload = {
      orderItems: orderItems,
      shippingAddress: state.shippingAddress,
      paymentMethod: state.paymentMethod,
      totalPrice: getters.cartTotalPrice.toFixed(2),
      orderID: orderID,
    };
    logBeginCheckout(state.cartItems, getters.cartTotalPrice);
    logAddPaymentInfo(state.paymentMethod, getters.cartTotalPrice);
    return axios.post("/api/orders", payload).then((res) => {
      if (res.data.success) {
        commit("ORDER_SUBMITTED_SUCCESS");
      } else {
        commit("ORDER_SUBMITTED_FAILED");
      }
    });
  },
  onPaymentSuccess({ state, getters, commit }) {
    logPurchase(
      state.orderID,
      state.cartItems,
      getters.cartTotalPrice,
      state.paymentMethod
    );
    commit("ORDER_PAID_SUCCESS", true);
  },
};
